import { Grid, Button, Typography, Snackbar, Alert } from "@mui/material";
import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import Lista_Items_Dashboard from "./Componentes/Lista_Items_Dashboard";
import ModalCrearEditarItem from "../Secciones/Componentes/SubComponentes/ModalCrearEditarComida";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";

const pestanas = [
    { key: "menu",       label: "Menú" },
    { key: "titulo",     label: "Título destacados" },
    { key: "destacados", label: "Destacados" },
];

const Seccion_Items = ({
                           coleccion,
                           titulo = "Crear Nueva Imagen",
                           mostrarCrear = true,
                           mostrarEditar = true,
                           coleccionDestacados = null,
                           tituloDestacados = "Nuevo Destacado",
                           coleccionTituloDestacados = null,
                           mostrarPestanas = false,
                       }) => {
    const { sCell } = useResponsive();
    const [pestanaActiva, setPestanaActiva] = useState("menu");
    const [modalCrearOpen, setModalCrearOpen] = useState(false);
    const [modalDestacadosOpen, setModalDestacadosOpen] = useState(false);
    const [modalTituloOpen, setModalTituloOpen] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [mensajeExito, setMensajeExito] = useState('');

    const handleSuccess = (mensaje) => {
        setMensajeExito(mensaje);
        setOpenSnackbar(true);
    };

    // Si no hay pestañas, siempre mostramos "menu"
    const tab = mostrarPestanas ? pestanaActiva : "menu";

    return (
        <Grid container justifyContent={'center'} alignItems={'flex-start'} size={{ xs: 12 }}>

            {/* ── Pestañas — solo si mostrarPestanas=true ── */}
            {mostrarPestanas && (
                <Grid
                    container
                    size={{ xs: 12 }}
                    justifyContent={'center'}
                    sx={{ borderBottom: '2px solid #e0e0e0', pt: 2, pb: 0, gap: 1, px: 2 }}
                >
                    {pestanas.map((p) => (
                        <Button
                            key={p.key}
                            onClick={() => setPestanaActiva(p.key)}
                            variant={pestanaActiva === p.key ? "contained" : "outlined"}
                            size={sCell ? "small" : "medium"}
                            sx={{
                                borderRadius: '20px 20px 0 0',
                                borderBottom: 'none',
                                fontWeight: 600,
                                px: sCell ? 2 : 3,
                                fontSize: sCell ? 13 : 15,
                            }}
                        >
                            {p.label}
                        </Button>
                    ))}
                </Grid>
            )}

            {/* ── Contenido pestaña MENÚ ── */}
            {tab === "menu" && (
                <>
                    {mostrarCrear && (
                        <Grid container size={{ xs: 12 }} justifyContent={'center'}
                              sx={{ px: 3, pt: 3, pb: 2 }}>
                            <Grid container size={{ xs: 12, sm: 12, md: 10 }}
                                  justifyContent={sCell ? 'center' : 'flex-end'}>
                                <Button
                                    variant="contained" color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={() => setModalCrearOpen(true)}
                                    size="large"
                                >
                                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                                        {titulo}
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                    <Grid container justifyContent={'center'} alignItems={'center'}
                          size={{ xs: 12, sm: 12, md: 10 }}>
                        <Lista_Items_Dashboard
                            coleccion={coleccion}
                            mostrarEditar={mostrarEditar}
                        />
                    </Grid>
                </>
            )}

            {/* ── Contenido pestaña TÍTULO DESTACADOS ── */}
            {tab === "titulo" && coleccionTituloDestacados && (
                <>
                    <Grid container size={{ xs: 12 }} justifyContent={'center'}
                          sx={{ px: 3, pt: 3, pb: 2 }}>
                        <Grid container size={{ xs: 12, sm: 12, md: 10 }}
                              justifyContent={sCell ? 'center' : 'flex-end'}>
                            <Button
                                variant="contained" color="primary"
                                startIcon={<AddIcon />}
                                onClick={() => setModalTituloOpen(true)}
                                size="large"
                            >
                                <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                                    Subir imagen título
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent={'center'} alignItems={'center'}
                          size={{ xs: 12, sm: 12, md: 10 }}>
                        <Lista_Items_Dashboard
                            coleccion={coleccionTituloDestacados}
                            mostrarEditar={true}
                        />
                    </Grid>
                    <ModalCrearEditarItem
                        open={modalTituloOpen}
                        onClose={() => setModalTituloOpen(false)}
                        onSuccess={handleSuccess}
                        coleccion={coleccionTituloDestacados}
                    />
                </>
            )}

            {/* ── Contenido pestaña DESTACADOS ── */}
            {tab === "destacados" && coleccionDestacados && (
                <>
                    <Grid container size={{ xs: 12 }} justifyContent={'center'}
                          sx={{ px: 3, pt: 3, pb: 2 }}>
                        <Grid container size={{ xs: 12, sm: 12, md: 10 }}
                              justifyContent={sCell ? 'center' : 'flex-end'}>
                            <Button
                                variant="contained" color="primary"
                                startIcon={<AddIcon />}
                                onClick={() => setModalDestacadosOpen(true)}
                                size="large"
                            >
                                <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                                    {tituloDestacados}
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent={'center'} alignItems={'center'}
                          size={{ xs: 12, sm: 12, md: 10 }}>
                        <Lista_Items_Dashboard
                            coleccion={coleccionDestacados}
                            mostrarEditar={true}
                        />
                    </Grid>
                    <ModalCrearEditarItem
                        open={modalDestacadosOpen}
                        onClose={() => setModalDestacadosOpen(false)}
                        onSuccess={handleSuccess}
                        coleccion={coleccionDestacados}
                    />
                </>
            )}

            {/* Modal Crear principal */}
            {mostrarCrear && (
                <ModalCrearEditarItem
                    open={modalCrearOpen}
                    onClose={() => setModalCrearOpen(false)}
                    onSuccess={handleSuccess}
                    coleccion={coleccion}
                />
            )}

            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
                    {mensajeExito}
                </Alert>
            </Snackbar>
        </Grid>
    );
};

export default Seccion_Items;